import axios from 'axios';
import type { SurveyTemplatesResult } from './SurveyTemplate';

export async function getSurveyTemplates(): Promise<SurveyTemplatesResult> {
  const response = await axios.get('/api/survey-templates/templates');
  return response.data;
}
